import getDomainName from '@updater-core/interactors/shell/tracker/utils/getDomainName';
import setCookie from '@updater-core/interactors/shell/tracker/utils/setCookie';

export default function deleteItemFromStorage (name) {
  const expiration = new Date(0);
  setCookie(name, '', expiration.toGMTString(), getDomainName());
  localStorage.removeItem(name);
}
